import {
  ArticleHeading1,
  ArticleHeading2,
  ArticleHeading3,
  ArticleParagraph1,
  ArticleParagraph2,
  useDeviceType,
} from '@cian/ui-kit';
import { useSelector } from 'react-redux';
import { DiscountConditionItem } from 'shared/components/DiscountConditionItem';
import { selectMortrageInfo } from 'shared/selectors/selectMortrageInfo';
import { IUtpItemWithPercent } from 'shared/types/utp';

type TDiscountConditionItemContainerProps = IUtpItemWithPercent;

export const DiscountConditionItemContainer: React.FC<TDiscountConditionItemContainerProps> = props => {
  const device = useDeviceType();

  const mortrageInfo = useSelector(selectMortrageInfo);

  const isPhone = device === 'phone';

  const Title = isPhone ? ArticleHeading3 : ArticleHeading2;

  const Description = isPhone ? ArticleParagraph2 : ArticleParagraph1;

  const Percent = isPhone ? ArticleHeading3 : ArticleHeading1;

  return (
    <DiscountConditionItem
      mortrageInfo={mortrageInfo}
      device={device}
      Title={Title}
      Description={Description}
      Percent={Percent}
      {...props}
    />
  );
};
